import * as THREE from 'three';

export class Player {
    constructor(scene, camera) {
        this.scene = scene;
        this.camera = camera;
        
        // Player settings
        this.position = new THREE.Vector3(0, 20, 0);
        this.velocity = new THREE.Vector3(0, 0, 0);
        this.rotation = new THREE.Euler(0, 0, 0);
        this.speed = 20;
        this.rotationSpeed = 2.0;
        this.maxPitchAngle = Math.PI / 4; // 45 degrees
        
        // Create player model (sphere)
        const geometry = new THREE.SphereGeometry(1, 32, 32);
        const material = new THREE.MeshStandardMaterial({ 
            color: 0x3366FF,
            metalness: 0.3,
            roughness: 0.2
        });
        this.mesh = new THREE.Mesh(geometry, material);
        this.mesh.castShadow = true;
        this.mesh.position.copy(this.position);
        this.scene.add(this.mesh);
        
        // Set initial camera position
        this.updateCamera();
    }
    
    getPosition() {
        return this.position.clone();
    }
    
    updateCamera() {
        // Position camera behind and slightly above the player
        const cameraOffset = new THREE.Vector3(0, 3, -10);
        cameraOffset.applyEuler(this.rotation);
        
        this.camera.position.copy(this.position).add(cameraOffset);
        
        // Look at a point slightly ahead of the player
        const lookAtOffset = new THREE.Vector3(0, 0, 5);
        lookAtOffset.applyEuler(this.rotation);
        
        const lookAtPoint = this.position.clone().add(lookAtOffset);
        this.camera.lookAt(lookAtPoint);
    }
    
    update(deltaTime, inputController) {
        // Apply constant forward motion
        const forwardDirection = new THREE.Vector3(0, 0, 1);
        forwardDirection.applyEuler(this.rotation);
        forwardDirection.multiplyScalar(this.speed * deltaTime);
        
        this.position.add(forwardDirection);
        
        // Apply pitch control (up/down)
        if (inputController.up) {
            this.rotation.x = Math.max(this.rotation.x - this.rotationSpeed * deltaTime, -this.maxPitchAngle);
        } else if (inputController.down) {
            this.rotation.x = Math.min(this.rotation.x + this.rotationSpeed * deltaTime, this.maxPitchAngle);
        }
        
        // Apply yaw control (left/right)
        if (inputController.left) {
            this.rotation.y += this.rotationSpeed * deltaTime;
        } else if (inputController.right) {
            this.rotation.y -= this.rotationSpeed * deltaTime;
        }
        
        // Add a slight roll effect when turning
        const targetRollAngle = inputController.left ? Math.PI / 12 : (inputController.right ? -Math.PI / 12 : 0);
        this.rotation.z = THREE.MathUtils.lerp(this.rotation.z, targetRollAngle, 3 * deltaTime);
        
        // Apply mild auto-stabilization when no input
        if (!inputController.up && !inputController.down) {
            this.rotation.x = THREE.MathUtils.lerp(this.rotation.x, 0, deltaTime);
        }
        
        // Update player mesh
        this.mesh.position.copy(this.position);
        this.mesh.rotation.copy(this.rotation);
        
        // Update camera position
        this.updateCamera();
    }
} 